module.exports = __webpack_public_path__ + "static/2-b01addb74743de596bc3b92a67916c68.png";